import React from 'react';

export default function withEhsPageBehavior(Component) {
    return class extends React.Component {
        componentDidMount() {
            // scroll to the top
            window.scrollTo(0, 0);
        }

        render() {
            // pass everything through
            return <Component {...this.props} />;
        }
    };
}
